import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

export default class TimerOneShotNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Timer Completed';
        this.id = 'node_timer_completed';
        this.icon = 'IoIosTimer';
        this.linkedFeature = 'timers';

        this.outputs = [
            {
                name: 'Complete',
                portId: 'timer_complete',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'TIMER',
                name: 'Timer',
                settingType: SettingType.OPTION,
                refId: 'timer',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const TIMER = project.getFeature(this.getSettingValue('TIMER'));
            if (TIMER) {
                return `{{$${TIMER.getSettingValue('TIMER_NAME')}}} completed`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const TIMER = project.getFeature(this.getSettingValue('TIMER'));
        if (TIMER) {
            return `{{$${TIMER.getSettingValue('TIMER_NAME')}}} completed`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
This block is triggered when the specified timer has completed. 

Note: Stopping the timer before it has completely elapsed (i.e., using **Timer Stop**) will prevent the triggering of this block.`;
    }
}
